import { parse } from "ipaddr.js";
import { serverIp, new_pixel_id} from '../../config/constants'
import axios from 'axios'
import ReactPixel from 'react-facebook-pixel';
ReactPixel.init(new_pixel_id);

export async function  sentTrackingParams(parsed) {

    // console.log("qxx00 +++++++++: sentTrackingParams" );

    // console.log("qxx12 utm_source:" + parsed.utm_source);
    // console.log("qxx12 utm_medium:" + parsed.utm_medium);
    // console.log("qxx12 utm_campaign:" + parsed.utm_campaign);
    // console.log("qxx12 utm_content:" + parsed.utm_content);
    
    if (parsed.utm_campaign && parsed.utm_content && parsed.utm_medium && parsed.utm_source) {

        window.analytics.track('paramTracking', {
            utm_source: parsed.utm_source,
            utm_medium: parsed.utm_medium,
            utm_campaign: parsed.utm_campaign,
            utm_content: parsed.utm_content
        });

        console.log("qxx19: done tracking to segment");

        axios.post(serverIp + 'userdetails/saveParamTracking', {
            utm_source: parsed.utm_source,
            utm_medium: parsed.utm_medium,
            utm_campaign: parsed.utm_campaign,
            utm_content: parsed.utm_content
        })
            .then(function (response) {
                console.log(response);
            })
            .catch(function (error) {
                console.log(error);
            });
    }
}

//export async function send_facebook_viewContent (content_name, audience) {
    export function send_facebook_viewContent (content_name, audience) {
    console.log("umtt21 pixel +++++++++:send_facebook_viewContent");
    console.log("umtt22 pixel content_name:"+content_name);
    console.log("umtt23 pixel audience:"+audience);

        //facebook loggins.. 
        console.log("umtt24 pixel: ViewContent, content_name:" + content_name);
        ReactPixel.track('ViewContent', {
            content_name: content_name,
            content_category: audience,
            content_ids: [content_name],
            content_type: 'product'
        })
  
}


// WEBPACK FOOTER //
// ./src/components/newSite/MiscUtils.js